/**
 * 插件
 * */

// 错误捕获
import pluginError from './error';
// 日志插件
// import pluginLog from '@/plugins/log';
// 鉴权指令
import directiveAuth from './auth';
// 对话框
import sweetalert2 from './sweetalert2';

export default {
  async install(Vue) {
    // 插件
    Vue.use(pluginError);
    // Vue.use(pluginLog);
    Vue.use(sweetalert2);

    // 指令
    Vue.directive('auth', directiveAuth);
  }
};
